export const resources_en = {
  title: 'Resources',
  description:
    'Discover industry insights, news, and expert perspectives in global logistics.  ',
  jctrans: 'JCtrans',
  logistics: 'Logistics',
  blog: 'Blog',
  blogDescription: 'Global Logistics and Freight Forwarding Industry',
  search: 'Search',
  searchPlaceholder: 'Search by keywords',
  // Related blogs
  relatedBlogs: 'Related blogs',

  // Success Story
  successStory: 'Success Story',
  successStoryDescription:
    'Share how global freight forwarders achieve commercial success with JCtrans',
}

export const resources_cn = {
  title: '资讯中心',
  description: '汇聚全球物流行业洞察、新闻动态与专家观点。  ',
  jctrans: 'JCtrans',
  logistics: 'Logistics',
  blog: '知识分享',
  blogDescription: '分享行业知识，交流行业经验',
  search: '搜索',
  searchPlaceholder: '按关键词搜索',
  relatedBlogs: '相关文章',

  // Success Story
  successStory: '成功案例',
  successStoryDescription: '分享全球货代如何在JCtrans取得商业成功',
}
